import React, { useState } from "react";
import UploadFileComponent from "../../uploadFile/index";
import Icons from "../../../public/assets/svg";
import styles from "../../../styles/pages/demand.module.scss";
import Demanddata from "../../demandData/index";
import axios from "axios";
import endpoints from "../../../utility/endpoints";
import SuccessModal from "../../../pages/successModal";
import _get from "lodash/get";
import router from "next/router";
import Loader from "../../../components/Loader";
import { sessionTimeOutCheck, checkExpiry } from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function index(props) {
  //props.data.data.field_basic_content_component[2].component.content.field_no_result_image[0].file_url

  // console.log("demand page props no image---", props.data[2].component.content);
  //console.log("no result image  ---", props.data.data.field_basic_content_component[2].component.content.field_no_result_image[0].file_url);

  //console.log("demand data", props.data);

  const [noImageUrl, setNoImageUrl] = useState(props.data[2].component.content);
  const [loader, setloader] = useState(false);
  const [authData, setAuthData] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [fail, setFail] = useState(false);
  const [message, setMessage] = useState("Demand created successfully!");
  React.useEffect(() => {
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      //console.log("auth ----header", auth);
      setAuthData(auth);
    } catch (e) {
      console.log("eroor", e);
    }
  }, []);
  const demandData = props.data[0].component;
  const demandFormData = props.data[1].component;

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [showFileName, setShowFileName] = useState(false);
  const [getUpdatedDemands, setGetUpdatedDemands] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileError, setError] = useState(false);
  const uploadFile = (file, name) => {
    setFile(file);
    setError(false);
    setShowFileName(true);
  };

  const uploadButtonClick = async () => {
    //console.log("auth data state  ----");
    let formData = new FormData();
    if (file == null) {
      setError(true);
      return;
    } else {
      setError(false);
    }
    formData.append("demandFile", file);
    setLoading(true);
    setloader(true);

    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);
    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setAuthData(auth);
      await axios({
        method: "post",
        url: `${endpoints.baseUrl}/demands/createDemandExcel`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: formData,
      }).then((resp) => {
        setloader(false);
        if (resp.data.code == 200) {
          setMessage("File Uploaded Sucessfully");
          setSuccessModal(true);
          //console.log("response", resp);
          setShowFileName(false);
          setGetUpdatedDemands(!getUpdatedDemands);
          setLoading(false);
          setFail(false);
        } else if (resp.data.code == 403) {
          setloader(false);
          setLoading(false)
          localStorage.removeItem("auth");
          sessionStorage.clear();
          props.sessionTimeOutCheck(true);
        } else if (resp.data.code == 400) {
          setShowFileName(false);
          setMessage(resp.data.message);
          setSuccessModal(true);
          setLoading(false);
          setFail(true);
        }
      });
    } else {
      setLoading(false)
      setloader(false)
      props.sessionTimeOutCheck(true);
    }
  };
  // to dowload sample files
  const downloadSampleFile = async () => {
    //console.log("here");
    let demandFileResponse = await axios({
      method: "GET",
      url: `${endpoints.baseUrl}/demands/demandSampleFile`,
      headers: {
        Authorization: `${authData.accessToken}|${authData.email}`,
      },
    });
    //console.log("respDemand--", demandFileResponse.data.data);
    //demandFileResponse.data.data
    if (demandFileResponse.data.code == 403) {
      setLoading(false)
      setloader(false)
      props.sessionTimeOutCheck(true)
    }
    else {
      window.open(demandFileResponse.data.data);
    }
   
    //window.open(`${endpoints.fetchBlobUrl}/demandFileSample%20(1).xlsx`);
  };
  return (
    <div className={styles.demandContainer}>
      <div className={`${styles.uploadBtnWrapper} container`}>
        <div className={styles.uploadFileContainer}>
          <UploadFileComponent
            type="demand"
            uploadFile={uploadFile}
            uploaded={showFileName}
            fileType=".xlsx"
            value = "demandDocument"
          />
          {fileError ? (
            <div style={{ color: "red", fontSize: "10px" }}>
              Select Some File
            </div>
          ) : null}
        </div>

        <div className={styles.actionBtn}>
          <span className={styles.iconUpload} onClick={uploadButtonClick}>
            {" "}
            <Icons name="uploadicon" className={styles.uploadIcon}></Icons>
            {_get(
              props,
              "data[0].component.content.field_upload_file_button_text[0]",
              ""
            )}
          </span>
        </div>
        <div className={styles.downloadBtn}>
          <span className={styles.sampleUpload} onClick={downloadSampleFile}>
            {" "}
            {_get(
              props,
              "data[0].component.content.field_upload_file_button_text[1]",
              ""
            )}
          </span>
        </div>
      </div>
      {loader ? <Loader /> : null}
      <Demanddata
        data={demandData}
        demandFormData={demandFormData}
        getUpdatedDemands={getUpdatedDemands}
        loading={loading}
        globalData={props.globalData}
        noimageUrl={noImageUrl}
        demandTableDruplData={_get(
          props,
          "data[0].component.content.field_demand_table_filters",
          []
        )}
        fieldOptions={_get(
          props,
          "data[0].component.content.field_options",
          []
        )}
        fieldRowDetails={_get(
          props,
          "data[0].component.content.field_table_labels",
          []
        )}
        setLoading={setLoading}
      />
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Create Demand"}
          message={message}
          fail={fail}
          setFail={setFail}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);
